import { Heart } from "lucide-react";

export const AnnouncementBar = () => {
    return (
        <div
            className="w-full text-center py-2 text-xs md:text-sm tracking-wide safe-top"
            style={{ background: "var(--sss-pink)", color: "#fff" }}
            data-testid="announcement-bar"
        >
            <span className="inline-flex items-center gap-2">
                Baked with love. Made to share.
                <Heart size={14} fill="#fff" strokeWidth={0} />
            </span>
        </div>
    );
};
